module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar_wrapper"
  }, [_c('DaySwitcher', {
    staticClass: "day_switch",
    attrs: {
      "date_from": _vm.date.date_from,
      "date_to": _vm.date.date_to
    },
    on: {
      "setPreviousWeek": _vm.setPreviousWeek,
      "setNextWeek": _vm.setNextWeek
    }
  }), _c('CalendarBlock', {
    attrs: {
      "data": _vm.allData,
      "days": _vm.getDays,
      "loading": _vm.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5226ed20","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/tabs/schedule/components/schedulecalendar/SchedulerCalendar.vue
// module id = a855a5583932cd36673c
// module chunks = 6